
/**
 * Created by Fra on 09/05/22.
 */

// Main imports 
import React, {Button, Component, useState } from "react";
import { getServiceName } from "../../utils/consts";
import Cookies from "universal-cookie";

// Local imports 
import PageTitle from '../../components/PageTitle';
import getClients from "../../services/getClients";
import Table from '../../widgets/tables/Table';
import deleteClient from "../../services/deleteClient";
import { DialerSip } from "@material-ui/icons";

export default class Clients extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.options = [
      { value: 'All', label: 'All' }
    ]

    this.selectRef = React.createRef();

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      waitDialogVisible: false,
      selectPdfDatesVisible: false,
      mailCompaniesList: []
    }

    this.grid = 2;

    this.pdfElements = [];

    this.corsi = [];
    this.pageTitle = "Corsi";
    this.brokerId = undefined;
  }

  async reload(){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    
    this.clienti = await getClients(username, token);   
    this.setState({ isLoading: false });
  }

  async componentDidMount() {
      document.title = getServiceName() + ' - Clienti'
      await this.reload();
  }

  render () {

    const cookies = new Cookies();

    var headCells = [
      { id: 'ragioneSociale', numeric: false, disablePadding: true, label: 'Ragione Sociale' },
      { id: 'mail', numeric: true, disablePadding: false, label: 'Email' },
      { id: 'telefono', numeric: true, disablePadding: false, label: 'Telefono' },
      { id: 'startDate', numeric: false, disablePadding: false, label: 'Inizio DEMO' },
      { id: '_', numeric: true, disablePadding: false, label: '' },
    ];  

    this.searchCols = ['ragioneSociale'];

    return (
      <div id={Math.random()}>
        <PageTitle title="Clienti" button="CREA NUOVO" onClick={() => {
          window.location.href = '/admin#/admin/addClient';
        }}/>

        { !this.state.isLoading && <Table headCells={headCells} searchCols={this.searchCols} rows={this.clienti} mail={true} phone={false} calendar={false} pdf={false}
          onEventClick={(row) => {
          cookies.set('currentClient', row, { path: '/' });
          window.location.href = '/admin#/admin/editClient';
        }}

        onSendMail={(id) => {
          this.sendMailRef.current && this.sendMailRef.current.reset();
          this.setState({sendMailVisible: true, sendMailUserId: id}); } 
        }
        
        onDelete={async (id) => {
          if (window.confirm("Sei sicuro di voler rimuovere questo cliente?") == false) return;

          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });
          
          const cliente = this.clienti.filter((client) => client.id == id )[0];
          let resp = await deleteClient(username, token, cliente.db_name);
          if (resp.result == 'ok') {
            alert("Il cliente e il relativo database sono stati eliminati correttamente.");
          }
          this.reload();
        }} />}
     
      </div>
    );
  }
}

